import { ChartColumn } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const CompareIcon = DeckardIconWrapper({ Icon: ChartColumn });
